import Link from 'next/link';

import { getAssetUrl } from '@utils/common.utils';
import ImageComponent from '@components/common/ImageComponent/ImageComponent';

interface LinkedinButtonPropTypes {
  postTitle?: string;
  postUrl?: string;
  authorSocialLink?: string;
  visibleAtTop?: boolean;
}

const LinkedinButton = (props: LinkedinButtonPropTypes) => {
  const { postTitle, postUrl, authorSocialLink, visibleAtTop } = props;

  let link = '';

  if (postTitle && postUrl) {
    link = `https://www.linkedin.com/shareArticle?mini=true&url=${postUrl}&title=${postTitle}&summary=invideo.io/blogs`;
  } else if (authorSocialLink) {
    link = authorSocialLink;
  }
  return (
    <Link href={link}>
      <a target="_blank" rel="noreferrer">
        <ImageComponent
          elementype="native"
          loading={visibleAtTop ? 'eager' : 'lazy'}
          fetchpriority={visibleAtTop ? 'high' : 'auto'}
          width="36"
          height="36"
          src={getAssetUrl('common', '/social-media/linkedin-circle.svg')}
        />
      </a>
    </Link>
  );
};
export default LinkedinButton;
